import { useMemo } from 'react';

import { wizardSteps } from '../constants';
import { determineStepIndex } from '../helpers/determineStepIndex';
import { useKycData } from './useKycData';

export const useLastFilledStep = () => {
    const { data } = useKycData();
    const stepIndex = useMemo(() => (data?.data ? determineStepIndex(data.data) : -1), [data?.data]);
    const lastFilledStep = useMemo(
        () => wizardSteps[stepIndex < wizardSteps.length ? stepIndex + 1 : stepIndex],
        [stepIndex]
    );

    return { lastFilledStep, stepIndex };
};
